import type {z} from "zod";

import {AddClientNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addClientNoteTitleSchema = requiredStringSchema(
  AddClientNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const addClientNoteContentSchema = requiredStringSchema(
  AddClientNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const addClientNoteFormSchema = AddClientNoteBody.extend({
  title: addClientNoteTitleSchema,
  content: addClientNoteContentSchema,
});
export type AddClientNoteFormPayload = z.output<typeof addClientNoteFormSchema>;

export const draftAddClientNoteFormSchema = addClientNoteFormSchema.partial();
export type DraftAddClientNoteFormPayload = z.output<typeof draftAddClientNoteFormSchema>;
